<template>
  <v-dialog v-model="isOpen" max-width="600">
    <template v-slot:activator="{ on: dialog }">
      <v-tooltip top>
        <template v-slot:activator="{ on: tooltip }">
          <v-btn icon v-on="{...tooltip, ...dialog}">
            <v-icon>
              {{ videoIcon }}
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $vuetify.lang.t('$vuetify.map.driverTrips.actions.video') }}</span>
      </v-tooltip>
    </template>

    <v-card>

      <v-toolbar>
        <v-icon left>{{ downloadIcon }}</v-icon>
        <v-toolbar-title>{{ $vuetify.lang.t('$vuetify.map.videoDownload.title') }}</v-toolbar-title>

        <v-progress-linear :active="isLoading" indeterminate absolute bottom>
        </v-progress-linear>

        <v-spacer></v-spacer>

        <v-btn icon @click="isOpen = false">
          <v-icon>{{ closingIcon }}</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text class="mt-2">
        {{ $vuetify.lang.t('$vuetify.map.videoDownload.text', videoCount) }}
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="loadVideo" :disabled="isLoading">
          {{ $vuetify.lang.t('$vuetify.map.videoDownload.download') }}
        </v-btn>
      </v-card-actions>

    </v-card>
  </v-dialog>
</template>

<script>
import backend from '../../../backend'
import { mdiClose, mdiFileDownload, mdiFileVideo } from '@mdi/js'
import snackbarMixin from '../../../mixins/snackbarMixin'

export default {
  name: 'videoDownload',
  props: {
    userId: Number,
    travelStart: Number,
    videoCount: Number
  },
  mixins: [snackbarMixin],
  data: () => ({
    isOpen: false,
    isLoading: false,

    downloadIcon: mdiFileDownload,
    videoIcon: mdiFileVideo,
    closingIcon: mdiClose
  }),
  methods: {
    async loadVideo () {
      try {
        this.isLoading = true

        const result = await backend.downloadVideoArchive({
          user_id: this.userId,
          timestamp: this.travelStart,
          lang: this.$vuetify.lang.current
        })

        const url = window.URL.createObjectURL(new Blob([result.data], { type: result.headers['content-type'] }))
        const link = document.createElement('a')
        link.href = url

        link.setAttribute('download', result.headers.filename)
        link.click()
        window.URL.revokeObjectURL(url)
      } catch (e) {
        this.processFailedRequest(e)
      } finally {
        this.isLoading = false
        this.isOpen = false
      }
    }
  }
}
</script>

<style scoped>

</style>
